import { isObject } from './isObject';

export const isOfferADeal = (offer: any): boolean => {
  return isObject(offer) && offer.promotion_type === 'deal';
};
